/*
 * <blog-oversigt> — filtrene på blogoversigten.
 *
 * Samme grund til web-komponent som på Om os-siden: når Shopify gengiver en
 * sektion igen (temaeditoren og `shopify theme dev`), indsættes HTML'en med
 * innerHTML, og inline-scripts kører ikke. Et custom element kobles på af sig
 * selv, hver gang elementet indsættes.
 */
if (!customElements.get('blog-oversigt')) {
  customElements.define(
    'blog-oversigt',
    class BlogOversigt extends HTMLElement {
      connectedCallback() {
        this.panel = this.querySelector('[data-rr-produkter]');
        this.toggle = this.querySelector('[data-rr-toggle]');
        this.alleKnap = this.querySelector('[data-rr-alle]');
        this.produktKnapper = Array.from(this.querySelectorAll('[data-rr-produkt]'));
        this.opslag = Array.from(this.querySelectorAll('[data-rr-post]'));

        if (this.toggle) {
          this.toggle.addEventListener('click', () => {
            this.saetUdfoldet(this.toggle.getAttribute('aria-expanded') !== 'true');
          });
        }

        if (this.alleKnap) {
          this.alleKnap.addEventListener('click', () => {
            this.filtrer('');
            this.saetUdfoldet(false);
          });
        }

        this.produktKnapper.forEach((knap) => {
          knap.addEventListener('click', () => {
            // Klik på et allerede valgt produkt slår filtret fra igen
            const valgt = knap.getAttribute('aria-pressed') === 'true';
            this.filtrer(valgt ? '' : knap.dataset.rrProdukt);
            this.saetUdfoldet(true);
          });
        });
      }

      saetUdfoldet(aaben) {
        if (this.toggle) this.toggle.setAttribute('aria-expanded', aaben ? 'true' : 'false');
        if (this.panel) this.panel.dataset.aaben = aaben ? 'true' : 'false';
      }

      filtrer(produkt) {
        this.produktKnapper.forEach((knap) => {
          knap.setAttribute('aria-pressed', knap.dataset.rrProdukt === produkt ? 'true' : 'false');
        });

        this.opslag.forEach((opslag) => {
          opslag.hidden = produkt !== '' && opslag.dataset.rrPost !== produkt;
        });
      }
    }
  );
}
